import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "ccc_admin_token";
const EMAIL_KEY = "ccc_admin_email";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [email, setEmail] = useState(() => localStorage.getItem(EMAIL_KEY));
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const verify = async () => {
      const stored = localStorage.getItem(TOKEN_KEY);
      if (!stored) {
        setChecking(false);
        return;
      }
      try {
        await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${stored}` },
        });
      } catch (err) {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(EMAIL_KEY);
        setToken(null);
        setEmail(null);
      } finally {
        setChecking(false);
      }
    };
    verify();
  }, []);

  const login = async (loginEmail, password) => {
    const { data } = await axios.post(`${API}/auth/login`, {
      email: loginEmail,
      password,
    });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(EMAIL_KEY, data.email);
    setToken(data.access_token);
    setEmail(data.email);
    return data;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(EMAIL_KEY);
    setToken(null);
    setEmail(null);
  };

  const authHeader = () =>
    token ? { Authorization: `Bearer ${token}` } : {};

  return (
    <AuthContext.Provider
      value={{ token, email, checking, login, logout, authHeader, isAuthenticated: !!token }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
};
